import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FeedIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.2395 15.7724L19 17.5289V18.3862H5V17.5289L6.76048 15.7724V11.444C6.76048 10.0779 7.10279 8.89996 7.78742 7.91021C8.48603 6.89257 9.45708 6.23042 10.7006 5.92374V5.31734C10.7006 4.9549 10.8263 4.64473 11.0778 4.38684C11.3293 4.12894 11.6367 4 12 4C12.3633 4 12.6741 4.12894 12.9326 4.38684C13.1911 4.64473 13.3204 4.9549 13.3204 5.31734V5.92374C14.5499 6.23042 15.514 6.89954 16.2126 7.93112C16.8972 8.92087 17.2395 10.0918 17.2395 11.444V15.7724ZM12 21C11.5249 21 11.1128 20.8327 10.7635 20.4982C10.4142 20.1636 10.2395 19.7593 10.2395 19.2854H13.7605C13.7605 19.7593 13.5858 20.1636 13.2365 20.4982C12.8872 20.8327 12.4751 21 12 21Z'
                fill='currentColor'
            />
        </>
    ),
})

FeedIcon.displayName = 'FeedIcon'
